$(function () {
    $('#contenu_presse_papier').bind('paste',function(event){
        gestionEvenementColler(event);
    });
});

// Affiche le popup de gestion des VIP
function popupGestionVIP(idSimulation) {

    affichageMessageAttenteDelai();

    $.ajax({
        type: "POST",
        data: "velIdSimulation=" + idSimulation,
        url: "/4DCGI/Partenaires/TestAffichageVIPSimulation",
        success: function (data) {

            switch (data) {
                case "0":
                    ajouterErreur("Impossible de mettre ce dossier en VIP : tous les contrats ont été édités.");
                    cacherMessageAttente();
                    break;
                case "1":
                    $.ajax({
                        type: "POST",
                        data: "velIdSimulation=" + idSimulation,
                        url: "/4DCGI/Partenaires/GestionVIP_Ajax",
                        success: function (data) {
                            cacherMessageAttente();
                            $('#popupGestionVIPTitre').html("Gestion VIP du dossier " + idSimulation);
                            $('#popupGestionVIPContenu').html(data);
                            affichageDialogueBT('popupGestionVIP');
                        }
                    });
                break;
            }
        }
    });
}

// Permet de désigner une simulation comme VIP (création)
function designerSimulationVIP(idSimulation, vtActionVIP) {
    affichageMessageAttenteDelai();

    $.ajax({
        type: "POST",
        data: "velIdSimulation=" + idSimulation + "&velIdMotifVIP=" + $('#velIdMotifVIP').val() + "&vtCommentaireVIP=" + $('#vtCommentaireVIPHisto').val() + "&vtActionVIP=" + vtActionVIP,
        url: "/4DCGI/Partenaires/CreationVIP_Ajax",
        success: function (data) {
            switch (data) {
                // Erreur de droit
                case "1":
                    ajouterErreur("Vous n'avez pas les droits nécessaires pour désigner un dossier VIP");
                    break;
                // Motif non renseigné.
                case "2":
                    ajouterErreur("Impossible de désigner le dossier VIP sans motif.");
                    break;
                // Pas d'erreur
                case "0":
                    var $imgVIP = $('.imgVIP_' + idSimulation);
                    if($imgVIP.hasClass('far') > 0) {
                        $imgVIP.removeClass('far');
                        $imgVIP.addClass('fas');
                    }
                    else {
                        activerIconeVIPSimulation(idSimulation);
                    }
                    break;
            }

            cacherMessageAttente();
            fermerDialogueBT("popupGestionVIP");
        },
        error: function () {
            cacherMessageAttente();
            fermerDialogueBT("popupGestionVIP");
        }
    });
}

// Permet de supprimer le tag VIP d'une simulation
function supprimerVIP(idSimulation) {
    affichageMessageAttenteDelai();

    $.ajax({
        type: "POST",
        data: "velIdSimulation=" + idSimulation,
        url: "/4DCGI/Partenaires/SuppressionVIP_Ajax",
        success: function (data) {
            switch (data) {
                // Erreur de droit
                case "1":
                    ajouterErreur("Vous n'avez pas les droits de désigner un dossier VIP.");
                    break;
                // Simulation inconnue
                case "2":
                    ajouterErreur("Ce dossier est inconnu.");
                    break;
                // Simulation inconnue
                case "0":
                    desactiverIconeVIPSimulation(idSimulation);
                    break;
            }

            cacherMessageAttente();
            fermerDialogueBT("popupGestionVIP");
        },
        error: function () {
            cacherMessageAttente();
            fermerDialogueBT("popupGestionVIP");
        }
    });
}

function activerIconeVIPSimulation(idSimulation) {
    var $imgVIP = $('.imgVIP_' + idSimulation);
    if($imgVIP.hasClass('far') || $imgVIP.hasClass('fas')){
        if($imgVIP.hasClass('far') ) {
            $imgVIP.removeClass('far');
            $imgVIP.addClass('fas');
        }
    }
    else {
        var $newURL = $imgVIP.attr('src').replace('vip_desactive', 'vip');
        $imgVIP.attr('src', $newURL).css('opacity', '1');
    }
}

function desactiverIconeVIPSimulation(idSimulation) {
    var $imgVIP = $('.imgVIP_' + idSimulation);
    if($imgVIP.hasClass('far') || $imgVIP.hasClass('fas')){
        if($imgVIP.hasClass('fas')) {
            $imgVIP.removeClass('fas');
            $imgVIP.addClass('far');
        }
    }
    else {
        var $newURL = $imgVIP.attr('src').replace('vip', 'vip_desactive');
        $imgVIP.attr('src', $newURL).css('opacity', '.4');
    }
}

// Afiche les boutons de modification.
function afficheModification() {
    $('#divBoutonGestionVIP').hide();
    $('#divBoutonsModification').show();

    $('#divConsultationVIP').hide();
    $('#divCreationVIP').show();
}

// Cache les boutons de modification
function cacheModification() {
    $('#divBoutonGestionVIP').show();
    $('#divBoutonsModification').hide();

    $('#divConsultationVIP').show();
    $('#divCreationVIP').hide();
}

function ouvrirCommentaireVIP(velIdSimulation, vbAccessSaisirCommVIP) {

    if ($("#contientTous").length > 0) {
        $('#contientTous').empty();
    }

    showElement("#attenteCommentairesVIP", "d-flex");

    if (vbAccessSaisirCommVIP == 1) {
        $('#btnAnnulerCommentaireVIP').show();
        $('#btnAjouterCommentaireVIP').show();
        $('#btnFermerCommentaireVIP').hide();

        affichageDialogueBT("commentaireFormulaireModal", null, true, false, function(){ loadCommentairesVIP(velIdSimulation); });

        $('#btnAjouterCommentaireVIP').off('click').on('click', function () {
            var vtCommentaire = $("#vtCommentaireVIP").val();
            //var vtCheminFichierPressePapier = $("#cheminFichierPressePapier").val();
            //var vtContenuFichierB64 = $("#contenuFichierB64").val();
            var velIdExpediteurMsg = $("#velIdExpediteurMsg").val();
            var vtPersonneConcernee = $("#vtPersonneConcernee").val();

            if (vtCommentaire.length > 0) {
                const file = $('#commentaire-uploads').get(0).files[0] ?? null;
                ajoutCommentaire(velIdSimulation, vtCommentaire, file, velIdExpediteurMsg, true, vtPersonneConcernee);
            } else {
                $("#dialogConsulterTitre").html('Erreur');
                $("#dialogConsulterContenu").html('Le champ est vide. Vous devez saisir un commentaire.');
                affichageDialogueBT("dialogConsulter", "Erreur");
            }
        });
    } else { // Affichage commentaire uniquement

        $('#btnAnnulerCommentaireVIP').hide();
        $('#btnAjouterCommentaireVIP').hide();
        $('#btnFermerCommentaireVIP').show();

        affichageDialogueBT("commentaireFormulaireModal", null, true, false, function(){ loadCommentairesVIP(velIdSimulation); });
    }

}

function loadCommentairesVIP(velIdSimulation){
    showElement("#attenteCommentairesVIP", "d-flex");
    // Affichage des commentaires
    $.ajax({
        type: "POST",
        url: "/4DCGI/partenaires/affichageCommentairesVIP",
        dataType: "xml",
        data: {velIdSimulation: velIdSimulation},
        success: function (vtReponseXML) {
            affichageCommentaires(vtReponseXML);
        }
    });
}

function ajoutCommentaire(velIdSimulation, vtCommentaire, uploadedFile, velIdExpediteurMsg, afficheCommentaire, vtPersonneConcernee) {
    affichageMessageAttente("Envoi de votre message...");

    const formData = new FormData();
    formData.append('velIdSimulation', velIdSimulation);
    formData.append('vtCommentaire', vtCommentaire);
    formData.append('velIdExpediteurMsg', velIdExpediteurMsg);
    formData.append('vtPersonneConcernee', vtPersonneConcernee);

    if (uploadedFile instanceof File) {
        formData.append('file', uploadedFile);
    }

    window
        .fetch('/4DCGI/partenaires/correspondanceVIP', {
            method: 'POST',
            body: formData
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(response.statusText)
            }
            return response.text();
        })
        .then(vtReponseXML => {
            if (afficheCommentaire == true) {
                affichageCommentaires(vtReponseXML);
            }

            var message = "<b>Votre commentaire a &eacute;t&eacute; ajout&eacute;.</b>";
            $(vtReponseXML).find('commentaire').each(function (index) {
                var envoiEmail = $(this).find('envoiEmail').text();

                if (envoiEmail == "1") {
                    message += " <br>Un mail a &eacute;t&eacute; envoy&eacute; &agrave; votre correspondant."
                }
            });

            $("#dialogConsulterTitre").html('Information');
            $("#dialogConsulterContenu").html(message);
            affichageDialogueBT("dialogConsulter", "Information");

            $("#vtCommentaireVIP").val("");
            $("#cheminFichierPressePapier").val("");
            $("#contenuFichierB64").val("");
            $("#contenu_presse_papier").empty();
        })
        .catch(err => {
            window.alert(err.message);
        })
        .finally(() => {
            cacherMessageAttente();
        });
}

function affichageCommentaires(vtReponseXML) {

    var action = $(vtReponseXML).find('action').text();
    var nbComm = $(vtReponseXML).find('nbCommentaires').text();
    var idLastExp = $(vtReponseXML).find('dernierExp').text();
    var maxLength = 50;

    hideElement("#attenteCommentairesVIP");

    // Affichage des personnes de la simulation
    $('#vtPersonneConcernee').empty();

    $(vtReponseXML).find('personneConcernee').each(function (index) {
        var idPersonneConcernee = $(this).find('idPersonneConcernee').text();
        var nomPersonneConcernee = $(this).find('nomPersonneConcernee').text();

        $('#vtPersonneConcernee').get(0).append(new Option(nomPersonneConcernee, nomPersonneConcernee + "|" + idPersonneConcernee));
    });

    if (nbComm > 0) {

        $("#velIdExpediteurMsg").val(idLastExp);
        $('.aucunCommentaire').remove();

        if (action == 2) { // Affichae de tous les commentaires
            $('#contientTous').empty();
        }

        // Affichage des commentaires
        $(vtReponseXML).find('commentaire').each(function (index) {
            var id = $(this).find('id').text();
            var nom = $(this).find('auteur').text();
            var partenaire = $(this).find('partenaire').text();
            var perso = $(this).find('nomPersonneConcernee').text();
            var corps = $(this).find('corps').text();
            var datetime = $(this).find('date').text() + " " + $(this).find('heure').text();
            var vtPersonneConcernee = "";

            if (perso != "Tous les assurés") {
                vtPersonneConcernee = "<span class='personne_concernee'>Concerne : " + perso + "</span><br>";
            }

            var classCom = "message-recu";
            var avatar =
                "<div class='media-left'>" +
                    "<div class='avatar'></div>" +
                "</div>";

            if(partenaire == 1) {
                classCom = "message-envoye";
                avatar = "";
            }

            $('#contientTous').append(
                "<div class='contient contient-vip'>" +
                    "<div class='media mb-1'>" +
                        avatar +
                        "<div class='media-body'>" +
                            "<div class='message-vip " + classCom + "'>" +
                                "<div class='content'>" + vtPersonneConcernee + "<span>" + corps + "</span></div>" +
                                "<div class='auteur'>" + datetime + " | " + nom + " </div>" +
                            "</div>" +
                        "</div>" +
                    "</div>" +
                "</div>"
            );
        });

        $('#contientTous .contient').each(function (index) {
            maxLength += $(this).height();
        });

        $("#contientTous").scrollTop(maxLength);
    } else {
        $('#contientTous').empty();
        $('#contientTous').prepend("<div class='aucunCommentaire'>Aucun commentaire sur ce dossier</div>");
    }
}


/****** Ajout d'une capture d'ecran *******/
function gestionEvenementColler(event) {
    // We need to check if event.clipboardData is supported (Chrome)
    if (event.originalEvent.clipboardData) {

        // Get the items from the clipboard
        var items = event.originalEvent.clipboardData.items;

        //si cet élément existe, il est géré et on intercepte le contenu du presse papier pour l'envoyer en Ajax
        if (items) {
            // Loop through all items, looking for any kind of image
            for (var i = 0; i < items.length; i++) {
                if (items[i].type.indexOf("image") !== -1) {
                    // We need to represent the image as a file,
                    var blob = items[i].getAsFile();
                    uploadFile(blob);
                }
            }
        } else {
            //il n'existe pas, on essaie de gérer ça autrement
            setTimeout(gestionSansUploadAsynchrone, 1);
        }
        // If we can't handle clipboard data directly (Firefox),
        // we need to read what was pasted from the contenteditable element
    } else {
        // This is a cheap trick to make sure we read the data
        // AFTER it has been inserted.
        setTimeout(gestionSansUploadAsynchrone, 1);
    }
}

/**
 * RM#9931 - Envoi des fichiers au serveur en binaire au lieu de base64
 * @param file {File}
 */
function saveUpload(file) {
    const transfer = new DataTransfer();
    transfer.items.add(file);

    $('#commentaire-uploads').get(0).files = transfer.files;
}

function uploadFile(blob) {
    // RM#9931 - Envoi des fichiers au serveur en binaire au lieu de base64
    saveUpload(blob);

    /*envoiDonnees = new FormData();
    envoiDonnees.append('presse_papier', blob);
    // affichageMessageAttente();
    $.ajax({
        url: "/4DCGI/Gestionnaire/Upload_PressePapier",
        type: "POST",
        secureuri: false,
        data: envoiDonnees,
        processData: false,
        contentType: false,
        success: function (data, textStatus, errorStatus) {
            vtXML_Chemin = $(data).find('chemin');
            vtXML_Contenu = $(data).find('contenu');

            $('#cheminFichierPressePapier').val(vtXML_Chemin.text());
            $('#contenu_presse_papier').html('<img id=\"contenu_presse_papier\" src=\"' + vtXML_Contenu.text() + '\">');

            $('#contenu_presse_papier').addClass('non_selectionne');
            $('#contenu_presse_papier').removeClass('selectionne');

            // cacherMessageAttente();
        }
    });*/
}

function gestionSansUploadAsynchrone() {
    console.log("gestionSansUploadAsynchrone");
    //On va vérifier que la div contient une image collée grâce au navigateur
    if ($('#contenu_presse_papier').find("img").length > 0) {
        $('#contenu_presse_papier').find("img").each(function () {
            //Cette image gère elle même le contenu en B64, on copie le contenu de la balise dans le champ qui sera envoyé au serveur
            $('#contenuFichierB64').val($(this).attr('src'));
        });
    } else {     //si ce n'est pas une image, on vide la div pour éviter que l'utilisateur écrive du texte
        $('#contenu_presse_papier').empty();
    }
}